export default __webpack_public_path__ + "static/media/maintenance-green.4d5d5b69.svg";